<template>
  <el-config-provider :locale="locale" size="large">
    <!-- 全屏显示 -->
    <router-view />
<!--    <el-affix :style="{ position: 'fixed', top: '80%', right: '0','z-index':'99' }">
&lt;!&ndash;      <img :src="keFu.wechat_kefu" style="width: 200px;position: absolute; right: 70px;bottom:40px;" v-show="keFu.isShow">&ndash;&gt;
      <img
          v-if="keFu.active === 1"
          :src="keFu.wechat_kefu_1"
          style="width: 200px; position: absolute; right: 70px; bottom: 120px;"
      />
      <img
          v-if="keFu.active === 2"
          :src="keFu.wechat_kefu"
          style="width: 200px; position: absolute; right: 70px; bottom: 40px;"
      />

&lt;!&ndash;      <div style="background-color: #ffffff;">
        <img :src="require('/public/images/wechat.png')" style="width: 40px;"  v-show="!keFu.isHide" @mouseenter="keFu.isShow=true" @mouseleave="keFu.isShow=false">
        <el-icon v-show="!keFu.isHide" @click="keFu.isHide=true"><DArrowRight /></el-icon>
        <el-icon v-show="keFu.isHide" @click="keFu.isHide=false"><DArrowLeft /></el-icon>
      </div>&ndash;&gt;

      <div style="background-color: #ffffff; display: flex; flex-direction: column; gap: 10px; padding: 10px;">
        &lt;!&ndash; 按钮1 &ndash;&gt;
        <img
            :src="require('/public/images/wechat.png')"
            style="width: 40px; cursor: pointer;"
            @mouseenter="toggleKefu(1)"
        />
        &lt;!&ndash; 按钮2 &ndash;&gt;
        <img
            :src="require('/public/images/wechat.png')"
            style="width: 40px; cursor: pointer;"
            @mouseenter="toggleKefu(2)"
        />
      </div>
    </el-affix>-->

    <el-affix  v-if="store.state.userInfo && store.state.userInfo.is_sub_user === false" :style="{ position: 'fixed', top: '80%', right: '10px','z-index':'99', transform: 'translateY(-50%)' }">
      <!-- 悬浮按钮 -->
      <div class="kefu-box">
        <!-- 私人客服 -->
        <div class="kefu-btn" @mouseenter="toggleKefu(1)" @mouseleave="toggleKefu(null)">
          <el-icon><User /></el-icon>
          <div>私人客服</div>
        </div>
        <!-- 白色横线 -->
        <div class="kefu-divider"></div>

        <!-- 官方微信 -->
        <div class="kefu-btn" @mouseenter="toggleKefu(2)" @mouseleave="toggleKefu(null)">
          <el-icon><ChatDotSquare /></el-icon>
          <div>官方微信</div>
        </div>
      </div>

      <!-- 显示二维码图片 -->
      <img
          v-if="keFu.active === 1"
          :src="keFu.wechat_kefu_1"
          class="kefu-img"
      />
      <img
          v-if="keFu.active === 2"
          :src="keFu.wechat_kefu"
          class="kefu-img"
      />
    </el-affix>

  </el-config-provider>
</template>
<script lang="ts" setup>
import { ElConfigProvider } from "element-plus";
import zhCN from 'element-plus/dist/locale/zh-cn'
import zhTW from 'element-plus/dist/locale/zh-tw'
import en from 'element-plus/dist/locale/en'
import {onUnmounted, reactive, ref} from "vue"
import { lnguage, web_site} from '@/api/services'
import { useStore } from 'vuex'
import {useI18n} from "vue-i18n";


const store = useStore()
const language = ref('zh-CN')
const locale = ref('zhCN')
//初始化项目
const i18n = useI18n();

/*
//客服微信
const keFu = reactive({
    isHide:false,
    isShow:false,
    wechat_kefu:'',
});
*/
// 客服信息
const keFu = reactive({
  active: null as null | 1 | 2,
  wechat_kefu_1: '',
  wechat_kefu: ''
})


initSystem()

function initSystem() {
  getLanguage()
  greet()
}

//获取语言
function getLanguage(){
  lnguage().then((res) => {
    store.commit('setLanguageList', res.data)
    if(store.state.selectLanguage == ''){
      store.commit('setSelectLanguage', res.data[0].code)
      store.commit('setSelectLanguageName', res.data[0].name)
    }
    language.value = res.data[0].code
  }).catch((err) => {
    console.log("err");
  });
}

//获取站点配置
// 系统信息
web_site().then((res) => {
  keFu.wechat_kefu_1 = res.data.wechat_kefu
  keFu.wechat_kefu= res.data.wechat_kefu
  store.commit('setWebSite', res.data)
}).catch((err) => {
  console.log("appinfo err");
});

function greet() {
  i18n.locale.value = store.state.selectLanguage.replace(/-/g, "")
  //console.log(store.state.selectLanguage.replace(/-/g, ""))
  //locale.value = store.state.selectLanguage.replace(/-/g, "");
  //locale.value = store.state.selectLanguage.replace(/-/g, "")
  if(store.state.selectLanguage === 'zh-CN'){
    locale.value = zhCN
  }
  if(store.state.selectLanguage === 'zh-TW'){
    locale.value = zhTW
  }
  if(store.state.selectLanguage === 'en'){
    locale.value = en
  }
  if(store.state.selectLanguage === 'th-TH'){
    locale.value = en
  }
}
// 切换显示哪个客服图
function toggleKefu(index: 1 | 2) {
  keFu.active = keFu.active === index ? null : index
}

</script>
<style scoped lang="scss">
.kefu-box {
  background-color: #267fff;
  border-radius: 6px 6px 6px 6px;
  padding: 10px 10px; // 加大上下内边距
  margin-outside: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-size: 10px;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  margin-right: 5px;
}

.kefu-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

   .el-icon {
    font-size: 20px; // 或者更大，如 24px
     margin-bottom: 6px; // 增加图标和文字的垂直间距
  }

}
.kefu-btn div {
  text-transform: uppercase; // 转为大写
  font-size: 10px;           // 可选：调大字号
  font-weight: bold;         // 可选：加粗
}


.kefu-img {
  position: absolute;
  right: 70px;
  bottom: 40px;
  width: 120px;
}
.kefu-divider {
  width: 100%;          // 横线长度相对于按钮宽度
  height: 1px;         // 横线高度
  background-color: #ffffff;  // 白色横线
  opacity: 1;        // 半透明更柔和，可调
}
</style>